
export interface NotificacionUsuarioEncabezado{
    id: string;
    fechaHora: string;
    fechaHoraVisualizacion?: string;
    fechaHoraLectura?: string;
    titulo: string;
  }